<template>
  <div class="">
    <div class="w-full h-screen">
      <Alerta :mensagem-erro="mensagemDeErro" :mostra-alerta="mostrarAlerta" @closeAlert="fecharAlerta"></Alerta>
        <router-view />

    </div>

  </div>
</template>

<script>
import ModalLoading from "@/components/base/ModalLoading.vue";
import jwt_decode from "jwt-decode";
import modulos from "@/mock/modulos";
import Alerta from "@/components/base/Alerta.vue";

export default{
  name: "app",
  components: {Alerta, ModalLoading},
  data(){
    return{
      modules: modulos,
      usuario: undefined,
      usuarioKeycloak: undefined,
      ambiente: process.env.NODE_ENV,
      mensagemDeErro: undefined,
      mostrarAlerta: undefined
    }
  },
  created() {
    this.getUsuarioController();
  },
  computed:{

  },
  methods:{
    fecharAlerta() {
      this.mostrarAlerta=false
    },

    async getUsuarioController() {
      console.log('getUsuarioController')
        try{
          await this.$store.dispatch("serviceLoading",true);
          const response = await this.$store.dispatch("gateway/serviceGetUsuarioOnline");
          console.log('response',response)
          this.usuario = response;

        }catch (erro) {
          console.log('Erro ao carregar usuário',erro)
        }finally {
          await this.$store.dispatch("serviceLoading",true)
        }
    }
  }
}
</script>
